import React from 'react';
import {View} from 'react-native';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {setPayWallet} from '../../store/slices/auction';
import {Text, TextInput} from 'react-native-paper';
import {MetamaskAccountsButton} from './metamaskaccountsbutton';

export function PayDialogBody() {
  const dispatch = useAppDispatch();
  const wallet = useAppSelector(state => state.auction.payWallet);
  const winnerPrice = useAppSelector(
    state => state.auction.winnerPrice,
  );
  const walletPlaceholder = 'Payment Crypto Wallet';
  return (
    <View style={{width: '100%', height: 'auto'}}>
      <Text>
        As the winner you need to pay {winnerPrice} Matik to receive
        the media file
      </Text>
      <TextInput
        label={walletPlaceholder}
        style={{width: '100%'}}
        value={wallet}
        onChangeText={value => dispatch(setPayWallet(value))}
        mode={'outlined'}
      />
      <MetamaskAccountsButton type="pay" />
    </View>
  );
}
